enum HotkeyCommand {
  OPEN_SEARCH = 'openSearch',
  OPEN_SETTINGS = 'openSettings',
  DISMISS = 'dismiss',
  SEND_MESSAGE = 'sendMessage',
  SUBMIT_FORM = 'submitForm',
}

enum HotkeyScope {
  FIELD = 'field',
  PAGE = 'page',
  OVERLAY = 'overlay',
}

type HotkeyDefinition = {
  allowInEditable: boolean;
  code: string;
  descriptionKey: string;
  isModRequired: boolean;
  isShiftRequired: boolean;
  titleKey: string;
  visibleInReference: boolean;
};

type HotkeyRegistration = {
  allowInEditable?: boolean;
  command: HotkeyCommand;
  enabled?: () => boolean;
  handler: (event: KeyboardEvent) => void;
  scope: HotkeyScope;
};

const HOTKEYS: Readonly<Record<HotkeyCommand, HotkeyDefinition>> = {
  [HotkeyCommand.OPEN_SEARCH]: {
    allowInEditable: true,
    code: 'KeyK',
    descriptionKey: 'hotkeys.openSearch.description',
    isModRequired: true,
    isShiftRequired: false,
    titleKey: 'hotkeys.openSearch.title',
    visibleInReference: true,
  },
  [HotkeyCommand.OPEN_SETTINGS]: {
    allowInEditable: true,
    code: 'Comma',
    descriptionKey: 'hotkeys.openSettings.description',
    isModRequired: true,
    isShiftRequired: false,
    titleKey: 'hotkeys.openSettings.title',
    visibleInReference: true,
  },
  [HotkeyCommand.DISMISS]: {
    allowInEditable: false,
    code: 'Escape',
    descriptionKey: 'hotkeys.dismiss.description',
    isModRequired: false,
    isShiftRequired: false,
    titleKey: 'hotkeys.dismiss.title',
    visibleInReference: true,
  },
  [HotkeyCommand.SEND_MESSAGE]: {
    allowInEditable: true,
    code: 'Enter',
    descriptionKey: 'hotkeys.sendMessage.description',
    isModRequired: false,
    isShiftRequired: false,
    titleKey: 'hotkeys.sendMessage.title',
    visibleInReference: true,
  },
  [HotkeyCommand.SUBMIT_FORM]: {
    allowInEditable: true,
    code: 'Enter',
    descriptionKey: 'hotkeys.submitForm.description',
    isModRequired: false,
    isShiftRequired: false,
    titleKey: 'hotkeys.submitForm.title',
    visibleInReference: false,
  },
} as const;

const isMacPlatform = (): boolean => navigator.platform.toLowerCase().includes('mac');

export {
  HOTKEYS,
  HotkeyCommand,
  HotkeyScope,
  isMacPlatform,
  type HotkeyDefinition,
  type HotkeyRegistration,
};
